module.exports = __webpack_public_path__ + "media/images/icon__live@2x-56758e44574622fdf7100220c547c7c8.png";